<template>
  <v-card flat height="85vh">
    <v-tabs icons-and-text>
      <v-tab v-for="tab in tabs" :key="tab.title">
        {{ tab.title }}
        <v-icon left>{{ tab.icon }}</v-icon>
      </v-tab>
      <v-tab-item>
        <SessionesConfig />
      </v-tab-item>
      <v-tab-item>
        <BackupConfig />
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>
<script>
import SessionesConfig from "./SessionesConfig.vue";
import BackupConfig from "./BackupConfig.vue";
export default {
  data() {
    return {
      tabs: [
        { title: "Sesiones", icon: "mdi-account-key" },
        // { title: "Pendientes", icon: "mdi-timer-sand" },
        {
          title: "Respaldo",
          icon: "mdi-content-save-move-outline",
        },
      ],
    };
  },
  components: {
    SessionesConfig,
    BackupConfig,
  },
};
</script>